import { render, staticRenderFns } from "./vat-display.vue?vue&type=template&id=6529eef4&scoped=true&"
import script from "./vat-display.vue?vue&type=script&lang=ts&"
export * from "./vat-display.vue?vue&type=script&lang=ts&"
import style0 from "./vat-display.vue?vue&type=style&index=0&id=6529eef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6529eef4",
  null
  
)

export default component.exports